module.exports = __webpack_public_path__ + "img/reports.f394c434.png";